export default __webpack_public_path__ + "static/4-802ee4b00dd6204aeded5c37b54b2654.png";